iScreenWizard.factory('Emaillog', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('emaillog', params).then(function (response) {
                var emaillogs = response.data;
                resolve(emaillogs);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('emaillog/'+id).then(function (response) {
                var emaillog = response.data;
                resolve(emaillog);
            }, reject);
        });
    };

    return data;
});